import { dreamService } from "motw_core/Services/DreamService";
import * as React from "react";
import { activeDreamFilterStyle } from "source/app/presentation/MainPanel/Dreams/DreamFilterButtons/Filters/Helpers/ActiveDreamFilterClass";
import { clearedDreamFilters } from "source/app/presentation/MainPanel/Dreams/DreamFilterButtons/Helpers/clearedDreamFilters";
import Dreams from "source/app/presentation/MainPanel/Dreams/Dreams";
import { EGlyphicon } from "source/app/presentation/Shared/Glyphicon/EGlyphicon";
import Render from "source/app/presentation/Shared/Render";
import IconWithText from "source/app/services/Shared/IconWithText/IconWithText";
import { ESharedComponent } from "source/app/services/UI/State/ESharedComponent";
import { State } from "source/app/services/UI/State/State";
import { AreDreamsFiltered } from "../../Helpers/AreDreamsFiltered";
import { IDreamsState } from "../../IDreamsState";
import { DreamsMaxIcon } from "../Indicators/DreamsMaxIcon";
import { DreamsOverloadIcon } from "../Indicators/DreamsOverloadIcon";
import { EDA } from "motw_core/Dreams/EDreamAttribute";
import { NavigateToDreamsRoute } from "../../Routing/DreamsRouting";

export function ShowAdjacent({ dreams }: { dreams: Dreams }) {
    const adjacentDreams = dreams.state.dreamsdata.filter(
        dreamService.IsAdjacentDream
    );

    const dreamCount = dreams ? adjacentDreams.length : 0;

    const textToDisplay = `Adjacent (${dreamCount})`;

    return (
        <span style={{ color: `#39cbd3` }} {...ActiveDreamFilterClass(dreams)}>
            <IconWithText
                iconSuffix={EGlyphicon.knight}
                whenClicked={() => LoadAdjacentDreams()}
                displayAsBlock={false}
            >
                {textToDisplay}
            </IconWithText>
            <Render
                id="adjacentDreamsIcons"
                when={dreams.state.dreamsdata.length > 0}
            >
                <DreamsMaxIcon shouldDisplay={dreamCount === 10} />
                <DreamsOverloadIcon shouldDisplay={dreamCount > 10} />
            </Render>
        </span>
    );
}

export function LoadAdjacentDreams() {
    const dreams = State.ReadClass<IDreamsState>(ESharedComponent.Dreams);

    if (dreams) {
        NavigateToDreamsRoute(`Adjacent`);
        dreams.setState(adjacentOnlyFilters);
    }
}

const adjacentOnlyFilters: Partial<IDreamsState> = {
    ...clearedDreamFilters,
    onlyShowAdjacentDreams: true,
    excludedAttributes: [EDA[EDA.waypoint]],
};

function ActiveDreamFilterClass(dreams: Dreams) {
    const isFilterActive =
        AreDreamsFiltered(dreams.state) && dreams.state.onlyShowAdjacentDreams;

    const className = isFilterActive ? activeDreamFilterStyle : ``;
    return { className };
}
